enum PriceLabel {
  From = 'from',
  FixedPrice = 'fixedPrice',
  Max = 'max',
  Free = 'free',
}

export default PriceLabel;
